/**
 * useUpgradeSubscription hook
 *
 * TanStack mutation wrapping `billingApi.upgradeSite`. Always paid path —
 * resolves with the Stripe Checkout URL the caller redirects to.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { upgradeSite } from '../api/billingApi';

interface UpgradeResult {
  checkoutUrl: string;
}

export function useUpgradeSubscription() {
  const queryClient = useQueryClient();
  return useMutation<UpgradeResult, Error, string>({
    mutationFn: (siteId) => upgradeSite(siteId),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites', siteId, 'subscription'] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
